import { Component, OnInit } from '@angular/core';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { WorkElement, BreakElement } from 'app/shared/common/interface';
import { FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ViolationModel } from 'app/shared/violation-interface';
import { default as _rollupMoment } from 'moment';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { Lightbox } from 'ngx-lightbox';
import { fuseAnimations } from '@fuse/animations';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
@Component({
  selector: 'app-team-sheet',
  templateUrl: './team-sheet.component.html',
  styleUrls: ['./team-sheet.component.scss'],
  providers: [DatePipe],
  animations: fuseAnimations
})

export class TeamSheetComponent implements OnInit {
  reportingToDD: any = [];
  reportingToDDOrignal: any = [];
  empRole: string = '';
  profileId: string = '';
  teamMembersDetails: any = [];
  memberCount: number = 0;
  tenantId: string = '';
  profileInformation: any = {};
  skillsShow: boolean = false;
  selectedEmployeeProjectsList: any = [];
  isSkillsAvailable: boolean = false;
  rowGroupMetadata: any;
  hide: boolean = true;
  selectedTab = 'Timesheet';
  last5days = [];
  selectedDate = new Date();
  noData = false;
  noTable = true;
  startingTime: any;
  dataSource1 = new MatTableDataSource(workData);
  dataSource2 = new MatTableDataSource(breakData);
  displayedColumns: string[] = ['WorkProject', 'WorkTimeIn', 'WorkTimeOut', 'WorkHours'];
  displayedColumnsnew: string[] = ['BreakTimeIn', 'BreakTimeOut', 'BreakHours', 'Comments', 'Reasons'];
  firstTimeofday: any;
  inTime: Date;
  lastTimeofday: any;
  outTime: any;
  isClosed: boolean;
  startTime: any;
  graceStartTime: any;
  selectedResourceId: any;
  selectedLeaderProfileId: any;
  teamLeadName: any;
  noReportinPersons = false;
  teamMembers = [];
  totalReportingPersons = 0;
  selectedTeamMembers: any;
  selectedStatus = 'all';
  userStatus = '';
  profileImage = '';
  profileName = '';
  roleName = '';
  dedicatedBillable: any;
  fixedBillable: any;
  nonBillable: any;
  nonWorkingDays = [];
  workingDays: any;
  activities = [];
  userActivities = [];
  tabIndex = new FormControl(0);
  violationDate: Date = new Date();
  violationsData: ViolationModel[] = [];
  name: string;
  inTimeCount = 0;
  inCompletedHrsCount = 0;
  breakHrsCount = 0;
  imageDetails: any[];
  images = [];
  screenShotImage = [];
  billableCount: any = [];
  nonBillableCount: any = [];
  selectedProfileId: string = '';
  resourceAnalyticStatus: any = [];
  checkInTime: any;
  checkOutTime: any;
  checkOutWorkHours: string;
  imageURL: string = 'assets/images/avatars/profile.jpg';
  workHoursInfo: any;
  breakHoursInfo: any = [];
  isCheckIn: boolean = false;
  checkInWorkHours: string;
  billingList: any = [];
  checkBox: boolean = false;
  totalBillingDays: number = 0;
  interviewInfo: any = [];
  isInterviewLogAvailable: boolean = false;
  departmentList: any = [];
  selectedId: string;
  selectedName: string;

  constructor(
    private parseService: ParseService,
    private _lightbox: Lightbox,
    public dialog: MatDialog,
    private storageConfiguration: StorageConfiguration,
    private getReportingToService: GetReportingToService,
    private datePipe: DatePipe,
    private queryInterface: QueryInterface
  ) {
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.getDepartment();
    this.getReportingTo();
    this.last5Days();
    this.getBillingResources();
    this.getCheckInCheckOutInfo(new Date());
  }

  ngOnInit() {
    this.hide = true;
    this.chooseTeam();
  }

  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(async res => {
      this.reportingToDD = this.bindDropDown(res);
      this.reportingToDDOrignal = this.bindDropDown(res);      
    });
  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ id: a.value, name: a.label });
    });
    return dropDownItem;
  }

  async chooseTeam(event?: MatAutocompleteSelectedEvent) {  
    if (event) {
      this.selectedId = event.option.value;
       const selectedItem = this.reportingToDDOrignal.find(item => item.id == this.selectedId);
      if (selectedItem) {
        this.selectedName = selectedItem.name;
      } else {
        this.selectedName = '';
      }
    }
    this.memberCount = 0;
    this.teamMembersDetails = [];
    this.billableCount = [];
    this.nonBillableCount = [];

    this.getCheckInCheckOutInfo(new Date(), event ? event.option.value : this.profileId);
    let Profile = this.parseService.instance.Object.extend('Profile');
    let profile = new this.parseService.instance.Query(Profile);
    profile.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: event ? event.option.value : this.profileId });
    profile.equalTo('isActive', true);
    profile.equalTo('isLongLeave', false);
    let profileInfo = await profile.find();
    await this.getProfileInformation(event ? event.option.value : this.profileId);
    if (profileInfo.length > 0) {
      this.memberCount = profileInfo.length;

      var i = 0;
      for (let data of profileInfo) {
        i = i + 1
        var billingStatus = this.resourceAnalyticStatus.find(x => x.profileId == data.id);
        let teamInfo = {
          position: i,
          name: data.get('username'),
          id: data.id,
          billable: billingStatus ? billingStatus.billable : false,
          profileImage: data.get('profileImageInfo').url ? data.get('profileImageInfo').url : '../../../../../assets/images//avatars/profile.jpg'
        }
        this.teamMembersDetails.push(teamInfo);
      }
      this.billableCount = this.teamMembersDetails.filter(x => x.billable == true);
      this.nonBillableCount = this.teamMembersDetails.filter(x => x.billable == false);
    }
  }

  last5DaysScreenShots($event) {
    this.selectedDate = this.last5days[$event];
    this.getScreenshotImage(this.selectedDate);
  }

  getScreenshotImage(selectbydate) {
    if (selectbydate == undefined) {
      this.selectedDate = new Date();
    }
    this.imageDetails = [];
    let img = '';
    this.images = [];
    let description = '';
    let queryInstance = this.parseService.instance.Object.extend('UserScreenShots');
    let query = new this.parseService.instance.Query(queryInstance);
    let date = selectbydate != undefined ? selectbydate : new Date();
    let startend = this.startenddates(date);
    query.descending('createdAt');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.include('profileId');
    query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.selectedProfileId ? this.selectedProfileId : this.profileId });
    query.find().then(results => {
      results.forEach(element => {
        this.imageDetails = element.get('imageDetails');
        this.imageDetails.forEach(innerElement => {
          img = innerElement.apiUrl;
          let recordedTime = (new Date(innerElement.recordedTime));
          description = 'Screenshot';
          this.images.push({
            src: img,
            caption: recordedTime,
            thumb: img
          });
        });
      });
      this.screenShotImage = this.images;
    });
  }

  last5Days() {
    var result = [];
    for (var i = 0; i < 10; i++) {
      var d = new Date();
      d.setDate(d.getDate() - i);
      result.push(d);
    }
    this.last5days = result;
  }

  async getProfileInformation(profileId?: string) {
    debugger
    this.getResourceStatus(profileId);
    this.interviewLogs(profileId);
    this.selectedProfileId = profileId;
    let profileClass = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(profileClass);
    query.equalTo('isActive', true);
    query.include('location');
    query.include('department');
    query.include('role');
    query.include('organisation');
    query.equalTo('objectId', profileId);
    query.equalTo('tenantId', this.tenantId);
    query.limit(10000000);
    query.include('reportingTo');
    let results = await query.find();
    if (results.length > 0) {
      this.profileInformation = {};
      let profile = results[0];
      if (Object.keys(profile.get('officialInfo').length > 0)) { var doj = profile.get('officialInfo').reportingDate ? profile.get('officialInfo').reportingDate : '-'; }
      if (profile.get('skillSet').length > 0) { this.skillsShow = true; }
      if (profile.get('officialInfo').experience) { var year = profile.get('officialInfo').experience ? profile.get('officialInfo').experience.year : 0; }
      if (profile.get('officialInfo').experience) { var month = profile.get('officialInfo').experience ? profile.get('officialInfo').experience.month : 0; }

      let department = this.departmentList.find(x => x.id == profile.get('department').id)
      this.profileInformation = {
        name: profile.get('username'),
        email: profile.get('email'),
        doj: doj != "-" ? this.datePipe.transform(doj, 'MMM d, y') : '-',
        Designation: profile.get('role').get('name') ? profile.get('role').get('name') : '',
        Department: department ? department.name : '',
        profileImage: profile.get('profileImageInfo').url ? profile.get('profileImageInfo').url : '../../../../../assets/images/avatars/profile.jpg',
        skills: profile.get('skillSet') ? profile.get('skillSet') : '',
        Experiences: `${year ? year : 0} Year ${month ? month : 0} Months `
      }
      await this.getCheckInCheckOutInfo(new Date(), profile.id);
      await this.getEmployeeProjectDetails(profile.id);
      await this.last5DaysTimesheet(undefined);
      await this.last5DaysScreenShots(undefined);
    }
  }

  async getBillingResources() {
    this.resourceAnalyticStatus = [];
    let ResourceStatus = this.parseService.instance.Object.extend('ResourceStatus');
    let query = new this.parseService.instance.Query(ResourceStatus);
    let currentDate = await this.startenddates(new Date());
    query.greaterThan('createdAt', currentDate[0]);
    query.lessThan('createdAt', currentDate[1]);
    query.equalTo('tenantId', this.tenantId);
    query.include('user.profile');
    query.limit(1000000);
    let results = await query.find();
    if (results.length > 0) {
      for (let data of results) {
        let recourseBillingInfo = {
          profileId: data.get('user').get('profile').id,
          userName: data.get('user').get('username'),
          billable: data.get('resourceStatus') == 'Dedicated Billable' ? true : false,
        }
        this.resourceAnalyticStatus.push(recourseBillingInfo);
      }
    }
    else {
      this.resourceAnalyticStatus = [];
    }
  }

  async getEmployeeProjectDetails(profileId: string) {

    let User = this.parseService.instance.Object.extend('_User');
    let user = new this.parseService.instance.Query(User);
    user.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: profileId });
    let res = await user.find();

    let ProjectMembers = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(ProjectMembers);
    query.include('project');
    query.equalTo('tenantId', this.tenantId);
    query.equalTo('status', 'Assigned');
    query.equalTo('user', { __type: 'Pointer', className: '_User', objectId: res[0].id });
    query.limit(10000000);
    let results = await query.find();

    if (results.length > 0) {
      this.selectedEmployeeProjectsList = [];
      for (let data of results) {
        if (data.get('project').get('projectInfo').currentStatus == 'New' || data.get('project').get('projectInfo').currentStatus == 'In Progress') {
          this.selectedEmployeeProjectsList.push({
            name: data.get('project').get('projectInfo').projectName
          });
        }
      }
    }
  }

  startenddates(day) {
    let startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  dayafter(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  daybefore(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  last5DaysTimesheet($event) {
    this.selectedDate = this.last5days[$event];
    this.getTimesheet(this.selectedDate);
  }

  getTimesheet(selectbydate) {
    if (selectbydate == undefined) {
      this.selectedDate = new Date();
    }

    let userTimesheet = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(userTimesheet);
    let date = selectbydate != undefined ? selectbydate : new Date();
    let startend = this.startenddates(date);
    query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.selectedProfileId ? this.selectedProfileId : this.profileId });
    query.descending('createdAt');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.find().then(async results => {
      if (results.length == 0) {
        this.noData = true;
        this.noTable = false;
        this.dataSource1 = new MatTableDataSource(workData);
        this.dataSource2 = new MatTableDataSource(breakData);
        this.firstTimeofday = 0;
        this.lastTimeofday = 0;
      }
      else if (results.length == 1) {
        this.noData = false;
        this.noTable = true;
        let attendance = results[0];
        let workTime = attendance.get('workTime');
        let breakTime = attendance.get('breakTime');
        this.startingTime = attendance.get('agreedStartTime');
        this.formatStartTime(date.toISOString());
        this.inTime = new Date(attendance.get('inTime'));
        this.outTime = attendance.get('outTime');
        this.isClosed = attendance.get('isClosed');
        let totalAttendance = attendance.get('totalAttendance');
        await this.displayEvent(workTime, breakTime);
        this.firstTimeofday = this.secondsToHms(totalAttendance.worktime);
        this.lastTimeofday = this.secondsToHms(totalAttendance.breaktime);
      }
    });
  }

  formatStartTime(date) {
    var datePipe = new DatePipe('en-US');
    let startDate = datePipe.transform(date, 'MM/dd/yyyy');
    this.startTime = new Date(startDate + ' ' + this.startingTime);
    this.graceStartTime = new Date(new Date(startDate + ' ' + this.startingTime).getTime() + (16 * 60 * 1000));
  }

  displayEvent(workTime, breakTime) {
    let project = null, inTime = null, outTime = null, actualHours = null, breakHours = null, reasonobj = null,
      elt = null, reasonname = null, reasonComment1 = null, reasonComment2 = null, breakData = [];
    this.dataSource2 = new MatTableDataSource(breakData);
    workData = [];
    this.dataSource1 = new MatTableDataSource(workData);
    for (let i = 0; i < workTime.length; i++) {
      elt = workTime[i];
      inTime = this.time(new Date(elt.inTime));
      outTime = null;
      actualHours = null;
      project = null;
      if (
        elt.outTime != 0 && elt.outTime != null &&
        elt.actualHours != 0 && elt.actualHours != null &&
        elt.project != null
      ) {
        outTime = this.time(new Date(elt.outTime));
        actualHours = this.secondsToHms(Math.ceil(elt.actualHours / 1000));
        project = elt.project.name;

        workData.push({
          WorkProject: project,
          WorkTimeIn: inTime,
          WorkTimeOut: outTime,
          WorkHours: actualHours
        });
      }
      this.dataSource1 = new MatTableDataSource(workData);
    }
    for (let i = 0; i < breakTime.length; i++) {
      elt = breakTime[i];
      outTime = this.time(new Date(elt.outTime));
      (inTime = null),
        (breakHours = null),
        (reasonobj = null),
        (reasonname = null);
      (reasonComment1 = null);
      (reasonComment2 = null);
      if (elt.inTime != 0 && elt.inTime != null &&
        elt.breakHours != 0 && elt.breakHours != null &&
        elt.reason != null) {
        inTime = this.time(new Date(elt.inTime));
        breakHours = this.secondsToHms(Math.ceil(elt.breakHours / 1000));
        reasonobj = elt.reason;
        reasonname = reasonobj.reason;
        let reason = '';
        if (reasonname == 'Other') {
          reason = reasonobj.other;
        } else {
          reasonComment1 = reasonobj.subject == undefined ? '' : reasonobj.subject;
          reasonComment2 = reasonobj.withWho == undefined ? '' : reasonobj.withWho;
          reason = (reasonComment1 == '' && reasonComment2 == '') ? '' : reasonComment1.concat(' with ' + reasonComment2);
        }
        breakData.push({
          BreakTimeIn: outTime,
          BreakTimeOut: inTime,
          BreakHours: breakHours,
          Comments: reasonname,
          Reasons: reason
        });
      }
      this.dataSource2 = new MatTableDataSource(breakData);
    }
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay + ':' + sDisplay;
  }

  time(d) {
    return d.toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  }

  open(index: number): void {
    // open lightbox
    this._lightbox.open(this.screenShotImage, index);
  }

  async getCheckInCheckOutInfo(date, selectedProfileId?) {

    this.workHoursInfo = [];
    this.breakHoursInfo = [];
    this.isCheckIn = false;
    this.checkInWorkHours = '00:00:00';
    this.checkInTime = '00:00:00';
    this.checkOutTime = '00:00:00';
    this.checkOutWorkHours = '00:00:00';

    let queryInstance = this.parseService.instance.Object.extend('CheckInCheckout');
    let query = new this.parseService.instance.Query(queryInstance);

    let startend = this.startenddates(new Date(date));
    query.greaterThan('checkInDate', startend[0]);
    query.lessThan('checkInDate', startend[1]);

    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: selectedProfileId ? selectedProfileId : this.selectedProfileId ? this.selectedProfileId : this.profileId });
    let checkInCheckoutInfo = await query.find();

    if (checkInCheckoutInfo.length > 0) {
      this.isCheckIn = true;

      this.checkInWorkHours = checkInCheckoutInfo[0].get('totalWorkHours') ? checkInCheckoutInfo[0].get('totalWorkHours') : '00:00:00';
      this.checkOutWorkHours = checkInCheckoutInfo[0].get('totalBreakHours') ? checkInCheckoutInfo[0].get('totalBreakHours') : '00:00:00';
      this.checkInTime = new Date(checkInCheckoutInfo[0].get('inTime'));
      // this.checkOutTime = new Date(checkInCheckoutInfo[0].get('outTime'));

      let inOutInfo = checkInCheckoutInfo[0].get('InOut');

      if (inOutInfo[inOutInfo.length - 1].direction == 'in' && inOutInfo.length > 1) {
        let lastOutTime = new Date(inOutInfo[inOutInfo.length - 2].logDate).getTime();
        let convertIstTimeFormat = new Date(lastOutTime);
        convertIstTimeFormat.setHours(convertIstTimeFormat.getHours() - 5);
        convertIstTimeFormat.setMinutes(convertIstTimeFormat.getMinutes() - 30);

        this.checkOutTime = convertIstTimeFormat;
      }
      else if (inOutInfo[inOutInfo.length - 1].direction == 'out') {
        let lastOutTime = new Date(inOutInfo[inOutInfo.length - 1].logDate).getTime();
        let convertIstTimeFormat = new Date(lastOutTime);
        convertIstTimeFormat.setHours(convertIstTimeFormat.getHours() - 5);
        convertIstTimeFormat.setMinutes(convertIstTimeFormat.getMinutes() - 30);
        this.checkOutTime = convertIstTimeFormat;
      }

      this.workHoursInfo = [];
      this.breakHoursInfo = [];

      var i = 0;
      var j = 0;

      for (let data of checkInCheckoutInfo[0].get('InOut')) {

        var outTime = new Date(data.logDate).getTime();
        var convertIstTimeFormat = new Date(outTime);
        convertIstTimeFormat.setHours(convertIstTimeFormat.getHours() - 5);
        convertIstTimeFormat.setMinutes(convertIstTimeFormat.getMinutes() - 30);

        if (data.direction == 'in') {
          var checkInCheckoutDetails: any = {
            inTime: convertIstTimeFormat,
            inDirection: data.direction
          }
        }
        else if (data.direction == 'out') {
          i = i + 1;
          checkInCheckoutDetails.outDirection = data.direction;
          checkInCheckoutDetails.outTime = convertIstTimeFormat;
          checkInCheckoutDetails.position = i;

          let reamingHours = this.remainingHours(checkInCheckoutDetails.inTime, checkInCheckoutDetails.outTime);
          checkInCheckoutDetails.totalWorkHour = reamingHours;
          this.workHoursInfo.push(checkInCheckoutDetails);
          checkInCheckoutDetails = {};
        }

        if (data.direction == 'in' && checkInCheckoutInfo[0].get('InOut')[0] != data) {
          j = j + 1;
          checkInCheckoutBreak.inDirection = data.direction;
          checkInCheckoutBreak.inTime = convertIstTimeFormat;
          checkInCheckoutBreak.position = j;

          let breakHours = this.remainingHours(checkInCheckoutBreak.outTime, checkInCheckoutBreak.inTime);
          checkInCheckoutBreak.totalBreakHour = breakHours;
          this.breakHoursInfo.push(checkInCheckoutBreak);
          checkInCheckoutBreak = {};
        }
        else if (data.direction == 'out' && checkInCheckoutInfo[0].get('InOut')[checkInCheckoutInfo[0].get('InOut').length - 1] != data) {
          var checkInCheckoutBreak: any = {
            outTime: convertIstTimeFormat,
            outDirection: data.direction
          }
        }
      }

    }
  }

  remainingHours(checkIn, checkOut) {
    let remainHours = checkOut - checkIn;
    let hour: any = Math.abs(Math.floor((remainHours % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    let minutes: any = Math.abs(Math.floor((remainHours % (1000 * 60 * 60)) / (1000 * 60)));
    if (minutes < 10) { minutes = '0' + minutes; }
    if (hour < 10) { hour = '0' + hour; }
    return `${hour}:${minutes}`;
  }

  getCheckInCheckoutDate(event) {
    this.selectedDate = this.last5days[event];
    this.getCheckInCheckOutInfo(this.selectedDate)
  }

  async getResourceStatus(profileId: string) {
    let User = this.parseService.instance.Object.extend('_User');
    let UserInfo = new this.parseService.instance.Query(User);
    UserInfo.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: profileId });
    let profileDetails = await UserInfo.find();
    if (profileDetails.length > 0) { var userId = profileDetails[0].id }

    let ResourceStatus = this.parseService.instance.Object.extend('ResourceStatus');
    let query = new this.parseService.instance.Query(ResourceStatus);
    query.limit(15);
    query.descending('createdAt');
    query.equalTo('user', { __type: 'Pointer', className: '_User', objectId: userId ? userId : '' })
    let results = await query.find();
    this.billingList = [];
    if (results.length > 0) {
      for (let data of results) {
        this.billingList.push({
          date: this.datePipe.transform(data.get('createdAt'), "MMM d"),
          isBillable: data.get('resourceStatus') === 'Dedicated Billable' ? true : false
        });
      }
      this.totalBillingDays = this.billingList.filter(x => x.isBillable == true).length;
    }
  }

  interviewLogs(profileId: string) {
    let queryInstance = this.parseService.instance.Object.extend('InterviewInfo');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.equalTo('isActive', true);
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: profileId })
    query.descending('updatedAt');
    query.equalTo('interviewType', 'Client');

    query.limit(8);
    query.find().then(result => {
      if (result.length > 0) {
        this.interviewInfo = [];
        this.isInterviewLogAvailable = true;
        for (let data of result) {
          this.interviewInfo.push({
            scheduledDate: this.datePipe.transform(data.get('scheduledDate'), 'MMM d, y'),
            status: data.get('status')
          })
        }
      }
      else {
        this.isInterviewLogAvailable = false;
      }
    })
  }

  handleMissingImage(event) {
    this.profileInformation.profileImage = this.imageURL;
  }

  async getDepartment() {
    let result = [];
    this.queryInterface.executeQuery(this.parseService, 'TenantDepartment',
      [{ condition: 'equalTo', field: 'tenantId', value: this.tenantId }]).then(results => {
        if (results.length > 0) {
          for (let department of results) {
            this.departmentList.push({
              id: department.get('department').id,
              name: department.get('displayName'),
            });
          }
        }
        else {
          this.queryInterface.executeQuery(this.parseService, 'Department', [{ condition: 'equalTo', field: 'isActive', value: true },
          { field: 'name', condition: 'descending' }]).then(results => {
            for (let i = 0; i < results.length; i++) {
              let jsonText = JSON.stringify(results[i]);
              let departmentInfo = JSON.parse(jsonText);
              result.push({
                id: departmentInfo.objectId,
                name: departmentInfo.name
              });
            }
            this.departmentList = result;
          });
        }
      });
  }

  onSearchChange(searchText: string) {
    const keyword = new RegExp(searchText, 'gi');
    if (searchText != '') {
      this.reportingToDD = this.reportingToDDOrignal.filter((i) => {
        return i.name.match(keyword);
      });
    } else {
      this.reportingToDD = [...this.reportingToDDOrignal]
      // this.getReportingTo();
    }
  }

  clearName(){
    if(this.selectedName){
      this.selectedName = ''
    } 
    else{
      this.reportingToDD = [...this.reportingToDDOrignal]
      // this.getReportingTo();

    }
  }

}

let workData: WorkElement[] = [];
let breakData: BreakElement[] = [];
